import { Error } from 'components/common/error'
import { FullScreenSpinner } from 'components/common/fullScreenSpinner'
import { LeftSideMenuBar } from 'components/menu/leftSideMenu'
import { RoamingAlert } from 'components/menu/roamingAlert'
import { UpperNavBar } from 'components/menu/upperNavBar'
import useCompany from 'hooks/useCompany'
import useUser from 'hooks/useUser'
import React, { useEffect } from 'react'
import { Grid, Row } from 'react-flexbox-grid'
import styled from 'styled-components'
import { useAuth } from '../context/authContext'
import { Router } from '../router/router'

const Container = styled.div`
  padding-left: 0;
  padding-right: 18px;
  padding-bottom: 0;
`

const AlertRow = styled(Row)`
  flex-direction: row-reverse;
  /* Bring up to touch MenuBar */
  margin-top: -10px;
  /* Adjust for MenuBar height change */
  @media (max-width: 1024px) {
    margin-top: -20px !important;
  }
`

export function NavigationContainer(): JSX.Element {
  // Data
  const {
    isLoading: userIsLoading,
    isError: userIsError,
    error: userError,
    data: user
  } = useUser()
  const {
    isLoading: companyIsLoading,
    isError: companyIsError,
    error: companyError,
    data: company
  } = useCompany()

  const { login, permissions, error, loading } = useAuth()

  useEffect(() => {
    if (error) {
      login()
    }
  }, [error])

  // Check if we can render
  if (userIsLoading || companyIsLoading || loading) {
    return <FullScreenSpinner />
  }

  if (userIsError || companyIsError) {
    return (
      <Error
        message={`Failed to load ${
          userIsError ? 'user' : 'data'
        } for this account.`}
        error={userError || companyError}
      />
    )
  }

  return (
    <Container>
      <UpperNavBar />
      <LeftSideMenuBar permissions={permissions}>
        <Grid fluid style={{ paddingTop: '70px' }}>
          {company && user?.isRoaming && (
            <AlertRow>
              <RoamingAlert company={company} />
            </AlertRow>
          )}
          <Row style={{ flexDirection: 'column' }}>
            <Router />
          </Row>
        </Grid>
      </LeftSideMenuBar>
    </Container>
  )
}
